import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  Headline as SecondaryHeadline,
  Summary as SecondarySummary,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const FullDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const BottomItem = styled.div`
  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;

    min-inline-size: 0;
  }
`;

export const BottomDivider = styled.div`
  block-size: 1px;

  background-color: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    flex: none;
    align-self: stretch;

    inline-size: 1px;
    block-size: auto;
  }
`;

export const StyledSecondaryItem = styled(ContentItemHomeSecondaryV2)`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    text-transform: uppercase;
  }

  ${SecondaryHeadline} {
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
    letter-spacing: -0.32px;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  ${FullDivider},
  ${BottomRow} {
    order: 2;
  }

  ${theme.breakpoints.up("tablet")} {
    ${FullDivider},
    ${BottomRow} {
      order: 0;
    }
  }
`;

export const HeroImageLink = styled(EntityLink)`
  order: 1;

  display: block;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    order: 0;
  }
`;

export const StyledContentCoverImage = styled(ContentCoverImage)``;

export const StyledSeriesPrimary = styled(ContentItemHomeSecondaryV2)`
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 594px;
  }

  ${SecondaryHeadline} {
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    letter-spacing: -0.6px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 28px;
      letter-spacing: -0.7px;
    }
  }

  ${SecondarySummary} {
    color: #5a5a5a;
    font-size: 14px;
    line-height: 135%;
    letter-spacing: -0.14px;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }
`;

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const Title = styled.div`
  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;

  a {
    color: #000000;
    text-decoration: none;
  }
`;
